{
  "imprint-page": {
    "meta": {
      "title": "Beauty Booking: Impression",
      "description": "Impression"
    },
    "text": {
      "title": "Impression",
      "address-and-contact-data": "ADRESSE ET DONNÉES DE CONTACT CONFORMÉMENT À L'ARTICLE 5 DU TMG",
      "address": "Adresse",
      "commercial-register": "Registre du commerce",
      "contact": "Contact",
      "email": "Email",
      "legal-representatives": "Représentants légaux",
      "liability": "PASSIF",
      "liability-text-1": "Nous sommes responsables du contenu de nos sites Web conformément aux dispositions du droit général, en particulier à l'article 7, paragraphe 1, de la loi allemande sur les télémédias (TMG). Tous les contenus sont créés avec le plus grand soin et au mieux de nos connaissances. Dans la mesure où nous renvoyons à des sites web de tiers au moyen d'hyperliens sur nos sites web, nous ne pouvons garantir l'actualité, l'exactitude et l'exhaustivité des contenus liés, car ces contenus ne relèvent pas de notre domaine de responsabilité et nous n'avons aucune influence sur leur conception future. Si vous estimez qu'un contenu enfreint la législation en vigueur ou est inapproprié, veuillez nous en informer.",
      "liability-text-2": "Les informations juridiques figurant sur cette page, ainsi que toutes les questions et tous les litiges liés à la conception de ce site web, sont soumis aux lois de la République fédérale d'Allemagne.",
      "telephone": "Téléphone",
      "vat-id": "Identifiant TVA (Ust-ID)"
    }
  }
}
